import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";
// persist reducer
import PersistDataReducer from "./PersistData/reducer";
import LogoutReducer from "./auth/logout/reducer";
import SupportCategoriesReducer from "./support/supportCategories/reducer";
import SupportQueryReducer from "./support/raiseQuery/reducer";
import ShareEmailReportReducer from "./shareEmailReport/reducer";
import HomeInvestmentWithdrawalReducer from "./home_dashboard/totalinvestment_withdrawl/reducer";
import HomeTotalReturnsReducer from "./home_dashboard/total_return/reducer";
import HomeInvestmentSummeryReducer from "./home_dashboard/investment_summery/reducer";
import HomeFinanceLedgerReducer from "./home_dashboard/finance_ledger/reducer";
import HomePortfolioReducer from "./home_dashboard/home_portfolio/reducer";
import HomeTradeConfirmMonthsReducer from "./home_dashboard/home_tradeConfirmation/reducer";
import HomeTradeConfirmDataReducer from "./home_dashboard/home_tradeConfirmationData/reducer";
import ContractNoteListReducer from "./contractNote/contractNote_list/reducer";
import ContractNoteSingleReducer from "./contractNote/contractNote_singledownload/reducer";
import ContractNoteProcessReducer from "./contractNote/contractNote_process/reducer";
import ContractNoteZipReducer from "./contractNote/contractNote_zip/reducer";
import AddProfileImageReducer from "./profileAddImage/reducer";
import AnnexureDetailsReducer from "./Annexure/AnnexureDetails/reducer";
import profileUpdatePasswordReducer from "./UpdatePasswordProfile/reducer";
import AddAnnualIncomeReducer from "./EditProfile/AddIncome/reducer";
import ListStateCityReducer from "./EditProfile/ListStateCity/reducer";
import AddNomineeDetailReducer from "./EditProfile/AddNominee/reducer";
import Re_KycDigioRequestReducer from "./Re_kyc/Digio_Request/reducer";
import Re_KycSendEmailOtpReducer from "./Re_kyc/Email_Verify/Send_Otp/reducer";
import Re_KycEmailVerifyOtpReducer from "./Re_kyc/Email_Verify/Verify_Otp/reducer";
import Re_KycSendPhoneOtpReducer from "./Re_kyc/Phone_Verify/Send_Otp/reducer";
import Re_KycDigioRequestResponseReducer from "./Re_kyc/Digio_Request_Response/reducer";
import Re_KycBankVerifyReducer from "./Re_kyc/BankVerify/reducer";
import Re_KycNomineeNotOptedReducer from "./Re_kyc/Nominee_Not_Opted/reducer";
import Re_KycEsignRequestReducer from "./Re_kyc/EsignRequest/reducer";
import Re_KycKRA_DataReducer from "./Re_kyc/KRA_Data/reducer";
import Re_KycKRA_Esign_DocumentReducer from "./Re_kyc/E_Sign_Document/reducer";
import Re_KycUpdatePersonalDetailsReducer from "./Re_kyc/UpdatePersonalDetails/reducer";
import Re_KycUpdateOthersDetailsReducer from "./Re_kyc/UpdateOtherDetails/reducer";
import Re_KycBranchDetailsReducer from "./Re_kyc/BranchDetails/reducer";
import Re_KycAddBankReducer from "./Re_kyc/AddBank/reducer";
import Re_KycUpdateBankReducer from "./Re_kyc/UpdateBank/reducer";
import Re_KycUploadDocumentsRekycReducer from "./Re_kyc/UploadDocuments_Re_Kyc/reducer";
import Re_KycAccountClosureReducer from "./Re_kyc/AccountClosure/reducer";
import Re_KycSendApplicationReducer from "./Re_kyc/SendRekycApplication/reducer";
import ReKycValidateDetailsReducer from "./Re_kyc/ValidatePersonalDetails/reducer";
import ReKycPanUtilityReducer from "./Re_kyc/PanUtility/reducer";


const appReducer = combineReducers({
    StoredData:PersistDataReducer,
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    Logout_user: LogoutReducer,
    Support_Get_Categories: SupportCategoriesReducer,
    Support_Raise_Query: SupportQueryReducer,
    Share_Email_Report: ShareEmailReportReducer,
    Home_Investment_Withdrawal: HomeInvestmentWithdrawalReducer,
    Home_Total_Returns: HomeTotalReturnsReducer,
    Home_Investment_Summery: HomeInvestmentSummeryReducer,
    Home_Finance_Ledger: HomeFinanceLedgerReducer,
    Home_Portfolio: HomePortfolioReducer,
    Home_TradeConfirmMonths: HomeTradeConfirmMonthsReducer,
    Home_TradeConfirm: HomeTradeConfirmDataReducer,
    ContractNote_List: ContractNoteListReducer,
    ContractNote_Single: ContractNoteSingleReducer,
    ContractNote_Process: ContractNoteProcessReducer,
    ContractNote_Zip: ContractNoteZipReducer,
    Add_Profile_Image: AddProfileImageReducer,
    Annexure_Get_Details: AnnexureDetailsReducer,
    // update profile password
    Profile_Update_Password: profileUpdatePasswordReducer,
    Add_Annual_Income: AddAnnualIncomeReducer,
    List_State_City: ListStateCityReducer,
    Add_Nominee_Detail: AddNomineeDetailReducer,
    
    // re_kyc
    Re_Kyc_Digio_Request: Re_KycDigioRequestReducer,
    Re_Kyc_Send_Email_Otp: Re_KycSendEmailOtpReducer,
    Re_Kyc_Email_Verify_Otp: Re_KycEmailVerifyOtpReducer,
    Re_Kyc_Send_Phone_Otp: Re_KycSendPhoneOtpReducer,
    Re_Kyc_Digio_Request_Response: Re_KycDigioRequestResponseReducer,
    Re_Kyc_Bank_Verify: Re_KycBankVerifyReducer,
    Re_kyc_nomineeNotOpted: Re_KycNomineeNotOptedReducer,
    Re_Kyc_Esign_Request: Re_KycEsignRequestReducer,
    Re_Kyc_KRA_Data: Re_KycKRA_DataReducer,
    Re_Kyc_Esign_Document_Download: Re_KycKRA_Esign_DocumentReducer,
    Re_Kyc_Update_Personal_Details: Re_KycUpdatePersonalDetailsReducer,
    Re_Kyc_Update_Others_Details: Re_KycUpdateOthersDetailsReducer,
    Re_Kyc_Fetch_Branch_Details: Re_KycBranchDetailsReducer,
    Re_Kyc_Add_Bank: Re_KycAddBankReducer,
    Re_Kyc_Update_Bank: Re_KycUpdateBankReducer,
    Re_Kyc_UploadDocumentsRekyc: Re_KycUploadDocumentsRekycReducer,
    Re_Kyc_Account_Closure: Re_KycAccountClosureReducer,
    Re_Kyc_Send_Request_Application: Re_KycSendApplicationReducer,
    ReKycValidateDetails: ReKycValidateDetailsReducer,
    ReKycPanUtility: ReKycPanUtilityReducer,
    
});

const rootReducer = (state, action) => {
    if (action.type === "RESET_ALL") {
        state = {
          StoredData: state?.StoredData,  // keep persisted data
        };
      }
      
    return appReducer(state, action);
  };
export default rootReducer;